import React, { useState } from "react";
import "./CheckoutPage.css";

const CheckoutPage = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [isAccepted, setIsAccepted] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("standard");

  const plans = {
    standard: {
      name: "Standard Plan",
      price: 99.0,
      features: [
        "High-quality visuals",
        "Basic captions & hashtags",
        "Weekly posting schedule",
        "1 social channel included",
        "Email Campaign Support",
      ],
      buttonText: "Choose $99/Month",
    },
    premium: {
      name: "Premium Plan",
      price: 199,
      features: [
        "Premium high-quality visuals",
        "Advanced captions & hashtags",
        "Daily posting schedule",
        "3 social channels included",
        "Priority Email Campaign Support",
        "Analytics & Reporting",
      ],
      buttonText: "Choose $199/Month",
    },
  };

  const formatCardNumber = (value) => {
    // Remove all non-numeric characters
    const numbersOnly = value.replace(/\D/g, "");

    // Add spaces every 4 digits
    const formatted = numbersOnly.replace(/(\d{4})(?=\d)/g, "$1 ");

    // Limit to 19 characters (16 digits + 3 spaces)
    return formatted.substring(0, 19);
  };

  const formatExpirationDate = (value) => {
    // Remove all non-numeric characters
    const numbersOnly = value.replace(/\D/g, "");

    // Add slash after 2 digits
    if (numbersOnly.length >= 2) {
      return numbersOnly.substring(0, 2) + " / " + numbersOnly.substring(2, 4);
    }

    return numbersOnly;
  };

  const handleCardNumberChange = (e) => {
    const formatted = formatCardNumber(e.target.value);
    setCardNumber(formatted);
  };

  const handleExpirationChange = (e) => {
    const formatted = formatExpirationDate(e.target.value);
    setExpirationDate(formatted);
  };

  const handleSecurityCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setSecurityCode(value.substring(0, 4));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isAccepted) {
      alert("Please accept the Terms & Conditions and Refund Policy");
      return;
    }
    // Handle payment submission
    console.log("Payment submitted for plan:", selectedPlan);
  };

  const handlePlanSelect = (planKey) => {
    setSelectedPlan(planKey);
  };

  return (
    <div className="checkout-container">
      <div className="checkout-choose-subscription-plan-container">
        <h2 className="checkout-choose-plan-title">Summary</h2>

        {/* <div className="checkout-plans-grid">
          {Object.entries(plans).map(([planKey, plan]) => (
            <div 
              key={planKey}
              className={`checkout-plan-card ${selectedPlan === planKey ? 'checkout-selected' : ''}`}
              onClick={() => handlePlanSelect(planKey)}
            >
              <h3 className="checkout-plan-name">{plan.name} includes</h3>
              <div className="checkout-plan-features">
                {plan.features.map((feature, index) => (
                  <div key={index} className="checkout-feature-item">
                    <div className="checkout-feature-checkmark">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span className="checkout-feature-text">{feature}</span>
                  </div>
                ))}
              </div>
              <button className="checkout-plan-checkout-btn">
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div> */}

        {/* Summary Section */}
        <div className="checkout-summary-section">
          <div className="checkout-summary-item">
            <div className="checkout-summary-details">
              <div className="checkout-summary-name">
                {plans[selectedPlan].name}
              </div>
              <div className="checkout-summary-qty">Qty 1</div>
              <div className="checkout-summary-description">
                Monthly subscription - ${plans[selectedPlan].price.toFixed(2)}
                /mo
              </div>
            </div>
            <div className="checkout-summary-price">
              ${plans[selectedPlan].price.toFixed(2)}
            </div>
          </div>
          <div className="checkout-summary-total">
            <div className="checkout-total-label">
              <span>Total</span>
              <span className="checkout-currency">USD</span>
            </div>
            <div className="checkout-total-price">
              <div className="checkout-total-amount">
                ${plans[selectedPlan].price.toFixed(2)}
              </div>
              <div className="checkout-total-period">
                ${plans[selectedPlan].price.toFixed(2)} / month
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="checkout-card">
        <h2 className="checkout-title">Payment</h2>

        <form onSubmit={handleSubmit} className="checkout-payment-form">
          <div className="checkout-payment-section">
            <div className="checkout-card-number-section">
              <label className="checkout-field-label">Card number</label>
              <div className="checkout-card-input-container">
                <input
                  type="text"
                  value={cardNumber}
                  onChange={handleCardNumberChange}
                  placeholder="1234 1234 1234 1234"
                  className="checkout-card-number-input"
                  maxLength={19}
                />
                <div className="checkout-card-icons">
                  <img src="/visa-icon.png" alt="Visa" className="checkout-card-icon" />
                  <img
                    src="/mastercard-icon.png"
                    alt="Mastercard"
                    className="checkout-card-icon"
                  />
                  <img
                    src="/amex-icon.png"
                    alt="American Express"
                    className="checkout-card-icon"
                  />
                </div>
              </div>
            </div>

            <div className="checkout-card-details-row">
              <div className="checkout-expiry-field">
                <label className="checkout-field-label">Expiration date</label>
                <input
                  type="text"
                  value={expirationDate}
                  onChange={handleExpirationChange}
                  placeholder="MM / YY"
                  className="checkout-expiry-input"
                  maxLength={7}
                />
              </div>

              <div className="checkout-security-field">
                <label className="checkout-field-label">Security code</label>
                <div className="checkout-security-input-container">
                  <input
                    type="text"
                    value={securityCode}
                    onChange={handleSecurityCodeChange}
                    placeholder="CVC"
                    className="checkout-security-input"
                    maxLength={4}
                  />
                  <span className="checkout-security-icon">?</span>
                </div>
              </div>
            </div>
          </div>

          <div className="checkout-authorization-text">
            By subscribing, you authorize Feedbird to charge you according to
            the terms until you cancel.
          </div>

          <div className="checkout-terms-section">
            <label className="checkout-checkbox-container">
              <input
                type="checkbox"
                checked={isAccepted}
                onChange={(e) => setIsAccepted(e.target.checked)}
                className="checkout-terms-checkbox"
              />
              <span className="checkout-checkmark"></span>
              <span className="checkout-terms-text">
                By signing up I accept the{" "}
                <span className="checkout-terms-link">Terms & Conditions</span> and{" "}
                <span className="checkout-terms-link">Refund Policy</span>.
              </span>
            </label>
            <p className="checkout-terms-subtext">
              View <span className="checkout-terms-link">Terms & Conditions</span> and{" "}
              <span className="checkout-terms-link">Refund Policy</span>
            </p>
          </div>

          Submit Button
        </form>
      </div> */}
      <button type="submit" className="checkout-complete-purchase-btn">
        Complete Purchase →
      </button>
    </div>
  );
};

export default CheckoutPage;
